import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Handles scroll behavior on route change:
//   • If the URL has a #hash, wait for the target element to exist (retry a few
//     times because sections may be rendered after async data loads), then scroll
//     to it. Respects `scroll-margin-top` from Tailwind (`scroll-mt-*`).
//   • Otherwise, jump to the top of the page.
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            return;
        }

        const id = hash.replace('#', '');
        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'auto', block: 'start' });
                return true;
            }
            return false;
        };

        // Try immediately, then retry a few times while the page/data is still loading.
        if (tryScroll()) return;
        let attempts = 0;
        const interval = setInterval(() => {
            attempts += 1;
            if (tryScroll() || attempts >= 20) {
                clearInterval(interval);
            }
        }, 150);
        return () => clearInterval(interval);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
